module.exports = __webpack_public_path__ + "static/media/logo_bulurah.fa9cd9cc.png";